export default __webpack_public_path__ + "static/media/close.bf336e02.svg";